<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/do0IKr/d2d_images/cover.jpg?1731429835394" alt="This image is the cover for the book Le Feu Intérieur"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Le Feu Intérieur
      </h1>
      <p class="bookDescription body article font2">
        <p>Sous la pression croissante de passer à l'étape suivante dans leur relation, la détective Sky Kelley annonce à son fiancé qu'elle préfère attendre. Mais il la quitte brusquement !<br/> Blessée dans son orgueil et cherchant à s'évader, Sky décide de s'immerger dans une mission audacieuse au cœur de ce monde obscur et sensuel.<br/> Lorsque le détective Jim O’Brien découvre que son ex-fiancée s'est engagée dans cette mission risquée, il est furieux. Elle est bien trop inexpérimentée pour un tel danger, et il se sent obligé de la suivre.<br/> Mais Jim réalise rapidement que Sky n’est pas une demoiselle en détresse, et elle le lui prouve de manière passionnée, bien au-delà de ses fantasmes...<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jan Springer, Chloé C
      </h2>
      
      <p class="authorDescription body article">Jan Springer, auteure reconnue du New York Times et du USA Today, se spécialise dans les romances érotiques pour les maisons d'édition Spunky Girl Publishing, Ellora's Cave, Totally Bound, Siren Bookstrand et Pocket Books. Elle réside en Ontario, Canada, dans un écrin de nature de deux hectares. Jan aime passer son temps à jardiner, faire de la randonnée, du kayak, ainsi qu'à lire et écrire. Elle est membre de la Writers Union of Canada et de la Romance Writers of America.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Spunky Girl Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?79e04a6a